export default __webpack_public_path__ + "static/media/selamat1.caec3569.svg";